<figure class="figure">
  <svg class="kaliuk kaliuk-big">
    <use href="'/assets/images/svg_ico/icons.svg#kaliuk2'"></use>
  </svg>
  <figcaption class="figure-caption">
    <h4 i18n="@@book-order.bookUnavailableTitle">This section is not available for you yet</h4>
    <p i18n="@@book-order.bookUnavailableMessage">
      To start using the booking feature, you need an Amadeus Selling Platform Connect license.
    </p>
    <a [routerLink]="getRouteParams(sellConnectSku$ | async)" class="btn btn-primary">Order now</a>
  </figcaption>
</figure>
